function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19 1.92l-6 16.75a.5.5 0 01-.47.33h-.16a.51.51 0 01-.46-.29l-2.36-5a2 2 0 01.34-2.21l3-3.28a.5.5 0 000-.69l-.38-.38a.5.5 0 00-.69 0l-3.28 3a2 2 0 01-2.21.34l-5-2.36A.51.51 0 011 7.67v-.16A.5.5 0 011.33 7l16.75-6a.5.5 0 01.52.11l.26.26a.5.5 0 01.14.55z"
});

var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 19",
    fill: "#9193A9"
  }, props), _ref);
};

export default SvgSend;